import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CampaignLogLayer from "../components/CampaignLogLayer";

const CampaignLogs = () => (
  <MasterLayout>
    <CampaignLogLayer />
  </MasterLayout>
);

export default CampaignLogs;
